import { useMediaQuery } from "react-responsive";
import stylesMobile from "./MangaMainSectionMobile.module.css"
import stylesDesktop from "./MangaMainSectionDesktop.module.css"

const MangaMainSectionMobile = ({manga}) => {
  return (
    <div className={stylesMobile.over_cont} itemScope itemType="https://schema.org/ComicSeries">
      <div className={stylesMobile.main_section}>
        {/* SEO мета-теги */}
        <meta itemProp="name" content={manga.title} />
        <meta itemProp="image" content={manga.cover_image?.core_url ||
                                        manga.cover_image?.selectel_url ||
                                        manga.cover_url ||
                                        '/logo/logo_mini_256_256.png'} />
        
        <p className={stylesMobile.main_description} itemProp="description">
          {manga.description}
        </p>
        
        <div className={stylesMobile.manga_tags}>
          <p className={stylesMobile.manga_tag} itemProp="genre">#{manga.tag}</p>
          {manga.genres.map((genre, i) => (
            <p key={`${genre}-${i}`} className={stylesMobile.manga_tag} itemProp="genre">
              {genre}
            </p>
          ))}
          {manga.artists.length > 0 && (
            <p className={stylesMobile.manga_tag} itemProp="translator">
              Переводчики: {manga.artists.join(', ')}
            </p>
          )}
        </div>

        <div className={stylesMobile.manga_options}>
          <div className={stylesMobile.options}>
            <p className={stylesMobile.translate} itemProp="publisher">
              Статус перевода: <span itemProp="publicationStatus">{manga.translation_status}</span>
            </p>
            <p className={stylesMobile.age_limit} itemProp="contentRating">
              Возрастное ограничение: <span>{manga.age_rating}+</span>
            </p>
            <p className={stylesMobile.release} itemProp="datePublished">
              Выпуск: <span>{manga.release_year}</span>
            </p>
          </div>
        </div>

        {/* Скрытые элементы для микроразметки */}
        <div itemProp="aggregateRating" itemScope itemType="https://schema.org/AggregateRating" style={{display: 'none'}}>
          <meta itemProp="ratingValue" content={manga.avg_rating} />
          <meta itemProp="ratingCount" content={manga.total_likes} />
          <meta itemProp="bestRating" content="10" />
        </div>

        <div itemProp="interactionStatistic" itemScope itemType="https://schema.org/InteractionCounter" style={{display: 'none'}}>
          <meta itemProp="interactionType" content="https://schema.org/ViewAction" />
          <meta itemProp="userInteractionCount" content={manga.total_views} />
        </div>
      </div>
    </div>
  )
}

const MangaMainSectionDesktop = ({manga}) => {
  return (
    <div className={stylesDesktop.over_cont} itemScope itemType="https://schema.org/ComicSeries">
      <div className={stylesDesktop.main_section}>
        {/* SEO мета-теги */}
        <meta itemProp="name" content={manga.title} />
        <meta itemProp="image" content={manga.cover_url} />
        
        <p className={stylesDesktop.main_description} itemProp="description">
          {manga.description}
        </p>
        
        <div className={stylesDesktop.manga_tags}>
          {/* <p className={stylesDesktop.manga_tag} itemProp="genre">#{manga.tag}</p> */}
          {manga.genres.map((genre, i) => (
            <p key={`${genre}-${i}`} className={stylesDesktop.manga_tag} itemProp="genre">
              {genre}
            </p>
          ))}
          {manga.artists.length > 0 && (
            <p className={stylesDesktop.manga_tag} itemProp="translator">
              Переводчики: {manga.artists.join(', ')}
            </p>
          )}
        </div>

        <div className={stylesDesktop.manga_options}>
          <div className={stylesDesktop.options}>
            <p className={stylesDesktop.translate} itemProp="publisher">
              Тип: <span itemProp="publicationStatus">{manga.type}</span>
            </p>
            <p className={stylesDesktop.translate} itemProp="publisher">
              Статус перевода: <span itemProp="publicationStatus">{manga.translation_status}</span>
            </p>
            <p className={stylesDesktop.age_limit} itemProp="contentRating">
              Возрастное ограничение: <span>{manga.age_rating}+</span>
            </p>
            <p className={stylesDesktop.release} itemProp="datePublished">
              Выпуск: <span>{manga.release_year}</span>
            </p>
          </div>
        </div>

        {/* Скрытые элементы для микроразметки */}
        <div itemProp="aggregateRating" itemScope itemType="https://schema.org/AggregateRating" style={{display: 'none'}}>
          <meta itemProp="ratingValue" content={manga.avg_rating} />
          <meta itemProp="ratingCount" content={manga.total_likes} />
          <meta itemProp="bestRating" content="10" />
        </div>

        <div itemProp="interactionStatistic" itemScope itemType="https://schema.org/InteractionCounter" style={{display: 'none'}}>
          <meta itemProp="interactionType" content="https://schema.org/ViewAction" />
          <meta itemProp="userInteractionCount" content={manga.total_views} />
        </div>
      </div>
    </div>
  )
}

const MangaMainSection = ({manga}) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });

  return isDesktop ? 
    <MangaMainSectionDesktop manga={manga}/> : 
    <MangaMainSectionMobile manga={manga}/>;
}

export default MangaMainSection